import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useCollectionMethodChartsDataContext } from './hooks/useCollectionMethodChartsDataContext';

export const FamiliesPerLocality = () => {
    const { chartData } = useCollectionMethodChartsDataContext();

    return (
        <SimpleBars
            title={'Total de Famílias por Localidade (Top 10)'}
            horizontal={true}
            subtitles={chartData?.familiesPerLocality?.map(
                (item) => item.description
            )}
            values={chartData?.familiesPerLocality?.map(
                (item) => item.total || 0
            )}
        />
    );
};
